import { BaseHttpService } from './base-http.service'

export default new (class AuthService extends BaseHttpService {
    getListPartners(path: string, params: any): Promise<any> {
        return super.postPromise(path, params)
    }

    getListInviteFromPartner(path: string, params: any): Promise<any> {
        return super.getPromise(path, params)
    }

    createPartner(path: string, params: any): Promise<any> {
        return super.postPromise(path, params)
    }

    confirmCooperate(path: string, params: any): Promise<any> {
        return super.putPromise(path, params)
    }

    deletePartner(path: string, params: any): Promise<any> {
        return super.postPromise(path, params)
    }
    acceptInvite(path: string, params: any): Promise<any> {
        return super.postPromise(path, params)
    }
})()